module.exports = __webpack_public_path__ + "img/designguide_2@2x.3d3dfd9.jpg";